module.exports = __webpack_public_path__ + "img/6e8624d21ac218a4245295e17bcd94e2.png";